export const getLanguageByLocale = (locale: string): string => locale.split('-')[0];
